const urlHelper = {
  getOperatordetails(payload: any) {
    return `/supply/operator/undertaking-details/${payload.opCode}`;
  },
  initiateUndertaking(payload: any) {
    return `/supply/operator/generate-undertaking/${payload.opCode}`;
  },
};

export default urlHelper;
